// src/pages/AllServices.js
import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import servicesBanner from "../assets/images/page-titles/1.webp";

function AllServices() {
  const [services, setServices] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const api_url =
    localStorage.getItem("api_url") || "http://localhost/inscape_backend/api/";
  const company_id = localStorage.getItem("company_id") || "1";
  const employee_id = localStorage.getItem("employee_id") || "1";

  useEffect(() => {
    fetchServices();
  }, []);

  useEffect(() => {
    // Apply background images after blogs are loaded
    if (!loading) {
      const timer = setTimeout(() => {
        document.querySelectorAll(".bg-img")?.forEach((el) => {
          const img = el.querySelector("img");
          if (img) {
            const parent = el.parentElement;
            if (parent) {
              parent.style.backgroundImage = `url(${img.src})`;
              parent.style.backgroundSize = "cover";
              parent.style.backgroundPosition = "center";
              parent.classList.add("bg-img");
              if (el.classList.contains("background-size-auto")) {
                parent.classList.add("background-size-auto");
              }
            }
            el.remove();
          }
        });
      }, 100);

      return () => clearTimeout(timer);
    }
  }, [loading]);

  const fetchServices = async () => {
    try {
      setLoading(true);
      setError(null);

      const formData = new FormData();
      formData.append("company_id", company_id);
      formData.append("employee_id", employee_id);
      formData.append("type", "1");

      const response = await fetch(`${api_url}service.php`, {
        method: "POST",
        body: formData,
      });

      const data = await response.json();

      if (data.status === "1" && data.result && data.result.length > 0) {
        setServices(data.result);
      } else {
        setError("No services found.");
        setServices([]);
      }
    } catch (err) {
      console.error("Error fetching services:", err);
      setError("Failed to load services. Please try again.");
      setServices([]);
    } finally {
      setLoading(false);
    }
  };

  const stripHtmlTags = (html) => {
    if (!html) return "";
    const tmp = document.createElement("DIV");
    tmp.innerHTML = html;
    return tmp.textContent || tmp.innerText || "";
  };

  const truncateText = (text, maxLength = 130) => {
    const stripped = stripHtmlTags(text);
    if (stripped.length <= maxLength) return stripped;
    return stripped.substring(0, maxLength) + "...";
  };

  const getServiceIcon = (index) => {
    const icons = [
      "icon-goal",
      "icon-financial-profit",
      "icon-strategy",
      "icon-agreement-1",
      "icon-reporting",
      "icon-risk-management",
      "icon-chart",
      "icon-consulting",
      "icon-handshake",
    ];
    return icons[index % icons.length];
  };

  return (
    <>
      {/* Banner Section */}
      <section className="page-title-layout3 page-title-light bg-parallax bg-overlay text-center">
        <div className="bg-img">
          <img src={servicesBanner} alt="background" />
        </div>
        <div className="container">
          <div className="row">
            <div className="col-12">
              <h1 className="pagetitle-heading">Our Services</h1>
              <nav>
                <ol className="breadcrumb justify-content-center mb-0">
                  <li className="breadcrumb-item">
                    <Link to="/">Home</Link>
                  </li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Services
                  </li>
                </ol>
              </nav>
            </div>
          </div>
        </div>
      </section>

      {/* Services Grid Section */}
      <section className="services-grid-section">
        <div className="container">
          {/* Section Header */}
          <div className="section-header">
            <h2>What We Offer</h2>
            <p>
              Explore our full range of accounting and tax services tailored for
              Australian firms.
            </p>
          </div>

          {/* Loading State */}
          {loading && (
            <div className="text-center py-5">
              <div className="spinner-border text-primary" role="status">
                <span className="visually-hidden">Loading...</span>
              </div>
              <p className="mt-3">Loading services...</p>
            </div>
          )}

          {/* Error State */}
          {!loading && error && (
            <div className="text-center py-5">
              <p className="text-danger mb-3">{error}</p>
              <button className="btn btn-primary" onClick={fetchServices}>
                Retry
              </button>
            </div>
          )}

          {/* Services Grid */}
          {!loading && !error && services.length > 0 && (
            <div className="row services-cards-row">
              {services.map((service, index) => (
                <div
                  key={service.service_id}
                  className="col-sm-6 col-md-6 col-lg-4"
                >
                  <Link
                    to={`/serviceDetails/${service.service_id}`}
                    className="service-modern-card"
                  >
                    {/* Icon */}
                    <div>
                      <div className="smc-icon-box">
                        <i className={getServiceIcon(index)}></i>
                      </div>

                      {/* Content */}
                      <div className="smc-content">
                        <h4 className="smc-title">
                          {service.service_title || "Untitled Service"}
                        </h4>
                        <p className="smc-desc">
                          {truncateText(service.service_short_dec, 130)}
                        </p>
                      </div>
                    </div>

                    {/* Footer */}
                    <div className="smc-footer">
                      <span>View More</span>
                      <div className="smc-arrow">
                        <i className="icon-arrow-up-right"></i>
                      </div>
                    </div>
                  </Link>
                </div>
              ))}
            </div>
          )}

          {/* Empty State */}
          {!loading && !error && services.length === 0 && (
            <div className="text-center py-5">
              <p className="text-muted">No services available at the moment.</p>
            </div>
          )}
        </div>
      </section>
    </>
  );
}

export default AllServices;
